(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var el=document.getElementById('cmp-carousel');
  if(!el) return;
  if(window.matchMedia('(min-width: 990px)').matches) return;
  if(!window.Flickity) return;
  if(el.__flktyInit) return;
  el.__flktyInit=true;
  new Flickity(el,{
    cellAlign:'center',
    wrapAround:true,
    contain:false,
    pageDots:true,
    prevNextButtons:true,
    draggable:true,
    selectedAttraction:0.02,
    friction:0.3
  });
});

  } catch(e) { console.error(e); }
})();
})();
